id: '**Entity_NotSyncedNotification_Table_Id**'
columns:
  id:
    indexGroups:
      - SOURCE_ID
      - KEYS
  hss_id:
    indexGroups:
      - TRACK_FOR_CHANGES
  pushed_notes:
    indexGroups:
      - TRACK_FOR_CHANGES
